import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";

export function NivelesHeader({
  totalGrupos,
  totalNiveles,
  modoCrear,
  onIniciarCrear,
}: {
  totalGrupos: number;
  totalNiveles: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Flujos de autorización"
      description={`${totalGrupos} flujo(s) · ${totalNiveles} nivel(es) total. Al pasar a LISTO_PARA_AUTORIZACION los niveles se resuelven y se congelan en la solicitud (decisión 35).`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo nivel
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
